import { all } from 'redux-saga/effects';
import * as masterCourseSagas from './containers/master-courses/saga';
import * as courseCreatorSagas from './containers/course-creator/saga';
import * as defaultCoursesSagas from './containers/default-courses/saga';
import * as setDefaultCourses from './containers/set-default-courses/saga';
import * as authenticationSagas from './components/with-auth/saga';

function* mainSaga() {
    yield all([
        masterCourseSagas.getMasterCoursesCountriesSaga(),
        masterCourseSagas.getMasterCoursesByCountrySaga(),
        masterCourseSagas.getMasterCoursesSaga(),
        masterCourseSagas.getSubjectsSaga(),
        courseCreatorSagas.getMasterCourseSaga(),
        courseCreatorSagas.saveCourseSaga(),
        courseCreatorSagas.publishCourseSaga(),
        courseCreatorSagas.getDefaultCourseSaga(),
        defaultCoursesSagas.getDefaultCoursesSaga(),
        defaultCoursesSagas.applySearchFilterSaga(),
        defaultCoursesSagas.filterDefaultCoursesSaga(),
        defaultCoursesSagas.archiveSelectedCourseSaga(),
        setDefaultCourses.getDefaulCoursesForCountrySaga(),
        setDefaultCourses.getCoursesForCountrySaga(),
        setDefaultCourses.saveDefaultCoursesForCountrySaga(),
        setDefaultCourses.saveDefaultCoursesSaga(),
        setDefaultCourses.getCoursesSaga(),
        authenticationSagas.checkUserIsAuthorizedSaga()
    ]);
}

export default mainSaga;



// WEBPACK FOOTER //
// ./app/main-saga.js